import { EndpointContract } from '../../architecture/ControllerContract';

import { z } from 'zod';
import { chat } from './Chat';
import { objectId } from '../ObjectId';
import { chatContext } from './ChatContext';

const body = z
    .object({
        sessionId: objectId,
        chatType: z.enum(['general', 'product-detail', 'product-comparison']),
        context: chatContext
    })
    .strict();

export const createChat = {
    verb: 'post',
    path: '',
    schema: {
        body,
        response: {
            200: chat
        }
    }
} as const satisfies EndpointContract;
export type CreateChat = z.infer<typeof body>;
